<template>
  <v-menu
    v-if="!editted"
    bottom
    content-class="bid-quantity-tooltip tooltip py-1"
    offset-y
    open-delay="200"
    open-on-hover
    transition="scale-transition">
    <template v-slot:activator="{ on }">
      <div
        :class="[{'secondary__green_not_active--text': item.bidStatus == 'DRAFT', 'secondary__red--text': red_text}, ' align-self-center']"
        v-on="red_text ? on : null">
        {{ formSum(quantity, null , 3) }} {{ unit }}
        <v-btn
          v-if="can_edit"
          icon
          small
          @click.stop="edit">
          <sIcon type="edit"/>
        </v-btn>
      </div>
    </template>
    <v-list
      v-if="red_text"
      dense>
      <v-list-item
        v-for="itemList in tooltip_list"
        :key="itemList.title">
        <v-list-item-content class="py-1">
          <v-list-item-subtitle class="h9-label">
            {{ itemList.title }}
          </v-list-item-subtitle>
          <v-list-item-title :class="[{'secondary__red--text': itemList.red}, 'h7-text text-start']">
            {{ itemList.quantity }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
  <v-text-field
    v-else-if="editted"
    ref="quantity"
    v-model="new_quantity"
    auto-grow
    autofocus
    class="quantity textfield pa-0 h7-text"
    color="var(--black-color)"
    hide-details
    rounded
    @blur="deactivate"
    @change="change"
    @click.stop=""
    @input="check"
    @keydown.enter="deactivate"
    @keydown.esc="deactivate"/>
</template>

<script>
import SmarttenderApi from '@/api/smarttenderApi'
const st_api = new SmarttenderApi()
import { modalMixin } from 'mixins'

export default {
  name: 'editSelectedQuantity',
  mixins: [modalMixin],
  data() {
    return {
      new_quantity: '',
      editted: false
    }
  },
  props: {
    tender: Object,
    item: Object,
    // winner: Boolean,
    show_selected_quantity: Boolean,

    change_winner_mode: Boolean,
    editable: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    quantity() {
      return this.show_selected && this.show_selected_quantity ? this.item.selectedQuantity || this.item.quantity : this.item.quantity
    },
    unit() {
      return this.item.unit?.title || '–'
    },
    show_selected() {
      let stat = this.tender.tenderStatus.id
      return this.item.selectedBid && (stat == 3 || stat == 10 || stat == 11 ||  stat == 12)
      // 7: {statusCode: 10, title: "Завершено", __typename: "TenderStatusGraph"}
      // 8: {statusCode: 11, title: "Закупівля не відбулась", __typename: "TenderStatusGraph"}
      // 9: {statusCode: 12, title: "Закупівля відмінена",
    },
    can_edit() {
      let stat = this.tender.tenderStatus.id
      return this.editable && this.item.selectedBid && (stat == 3 || this.change_winner_mode) && this.item.bidStatus == 'ACTIVE'
    },
    red_text() {
      let error_lot_q = this.item.lotQuantity && this.item.lotQuantity !=  this.item.quantity,
        error_selected_q = this.item.selectedQuantity &&  this.item.selectedQuantity !=  this.item.quantity
      return this.show_selected ? error_selected_q || error_lot_q : error_lot_q
    },
    tooltip_list() {
      let unit = ' ' + this.unit,
        items = [
          {
            title: this.$t('Tenders.QuantityFuggestedByTheParticipant'),
            quantity: this.formSum(this.item.quantity, null, 3) + unit,
            red: this.item.lotQuantity && this.item.lotQuantity !=  this.item.quantity
          },
          {
            title: this.$t('Tenders.TheRequiredAmount'),
            quantity: this.formSum(this.item.lotQuantity, null, 3) + unit,
          },
        ]
      if (this.show_selected) {
        items.push({
          title: this.$t('Tenders.SelectedQuantity'),
          quantity: this.formSum(this.item.selectedQuantity, null, 3) + unit,
          red: this.item.selectedQuantity && this.item.selectedQuantity !=  this.item.quantity
        })
      }
      return items
    }
  },
  methods: {
    edit() {
      this.editted = true
      this.new_quantity = this.item.selectedQuantity
    },
    change() {
      this.deactivate()
      if ( this.quantity != this.new_quantity  ) {
        this.new_quantity = +this.$_formatValue(this.new_quantity || 0)

        let updItem = () => {
          this.$set(this.item, 'selectedQuantity', this.new_quantity )
          this.tender.bids.some(bid => {
            if ( bid.bidderInfo?.usreou != this.item.org_num ) { return }
            bid.bidDetails.some( det => {
              if ( det.id == this.item.id ) {
                this.$set(det, 'selectedQuantity', this.new_quantity )
                return true
              }
            })
          })
        }

        if ( this.tender.tenderStatus.id == 3 ) {
          st_api.changeTenderWinner({
            tenderId: this.tender.tenderId,
            selectWinnerBidItemIds: [
              {
                bidItemId: this.item.id,
                quantity: this.new_quantity
              }
            ],
          })
            .then(res => {
              if (res?.success) {
                updItem()
              } else {
                this.$show_error_message( res )
              }
            })
        } else if ( this.change_winner_mode ) {
          updItem()
          this.$set(this.item, 'changedSelectedQuantity', this.item.changedSelectedQuantity || this.item.selectedQuantity )
          this.$root.$emit('changedWinnersFinishedTender', [this.item], true )
        }

      }
    },
    deactivate() {
      this.editted = false
    },
    check(text) {
      this.sliceText( text, this.$refs.quantity, 3, val => this.new_quantity = val , 9)
    }
  }
}
</script>

<style lang="scss">
.textfield.v-text-field > .v-input__control > .v-input__slot {
  padding: 0;
}
.bid-quantity-tooltip {
  .v-list-item__content {
    min-width: min-content;
    width: min-content;
  }
}
</style>
